/**
 * Removable chips for the currently selected On track sections. Each chip shows the section
 * label with its count and an "x" that removes the selection. Keyboard-operable.
 */
import { observer } from "mobx-react";
import IconClose from "../../../../../../../../../../../components/icons/icon-close/icon-close";

interface IProps {
    selected: string[];
    getLabel: (value: string) => string;
    getCount: (value: string) => number;
    disabled: boolean;
    onRemove: (value: string) => void;
}

const RmaListOnTrackBucketChips: React.FC<IProps> = observer(({ selected, getLabel, getCount, disabled, onRemove }) => (
    <div className="rma-list-on-track-bucket__chips">
        {selected.map((value) => (
            <div className="rma-list-on-track-bucket__chip" key={value}>
                <span className="rma-list-on-track-bucket__chip-label">
                    {getLabel(value)} ({getCount(value)})
                </span>
                <span
                    role="button"
                    tabIndex={disabled ? -1 : 0}
                    className="rma-list-on-track-bucket__chip-remove"
                    onClick={disabled ? undefined : () => onRemove(value)}
                    onKeyDown={(e) => {
                        if (disabled) {
                            return;
                        }
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            onRemove(value);
                        }
                    }}
                >
                    <IconClose />
                </span>
            </div>
        ))}
    </div>
));

export default RmaListOnTrackBucketChips;
